import React from 'react';
import { ArrowRightIcon, InfinityIcon } from 'lucide-react';
import { offers, Offer } from '../data/product';
interface FinalCtaProps {
  onSelectOffer: (id: Offer['id']) => void;
}
const buttonLabels: Record<Offer['id'], string> = {
  single: 'Get the X1 for $49.95',
  trio: 'Get 3 X1 Systems for $99.90',
  crew: 'Get 6 X1 Systems for $199.80'
};
export function FinalCta({
  onSelectOffer
}: FinalCtaProps) {
  return <section aria-labelledby="final-heading" className="border-b border-white/10 bg-ink-950" data-id="element-193" data-mp="1jbtylrlcl0ec">
      <div className="mx-auto max-w-[1400px] px-4 py-16 text-center sm:px-6 lg:px-8 lg:py-24" data-id="element-194" data-mp="1ed0h7o2xwp8w">
        <h2 id="final-heading" className="grit-headline mx-auto max-w-4xl text-[clamp(2.5rem,9vw,5.5rem)] font-extrabold uppercase text-offwhite" data-id="element-195" data-mp="1t1wqtpknaabm">
          Stop holding the light.
          <br data-id="element-196" data-mp="224ee87c1d907" />
          <span className="text-grit-500" data-id="element-197" data-mp="223w6adg0h6cg">Start wearing it.</span>
        </h2>

        <div className="mx-auto mt-6 max-w-md space-y-1 text-lg font-medium text-steel-300" data-id="element-198" data-mp="1x5unzuqetb21">
          <p data-id="element-199" data-mp="n6nrgzhyk6xb">Three lenses.</p>
          <p data-id="element-200" data-mp="n7p61dy6nbjs">Built-in illumination.</p>
          <p data-id="element-201" data-mp="s45te5xk5lvt">Both hands free.</p>
        </div>

        <p className="mx-auto mt-6 inline-flex items-center gap-2 border-2 gold-edge bg-[#1a1408] px-5 py-3" data-id="element-202" data-mp="s57el38afor9">
          <InfinityIcon className="h-6 w-6 shrink-0 text-[#f2c94c]" aria-hidden="true" data-id="element-203" data-mp="x5v6rs896bn2" />
          <span className="grit-headline text-2xl font-extrabold uppercase gold-text sm:text-3xl" data-id="element-204" data-mp="1246gm2yjsm5a">
            Break it. We replace it.
          </span>
        </p>

        <p className="mt-8 font-display text-3xl font-extrabold uppercase leading-none text-offwhite" data-id="element-205" data-mp="1b2ruhkt2rczq">
          GritVue X1™
        </p>
        <p className="mt-1 text-xs font-bold uppercase tracking-[0.3em] text-grit-500" data-id="element-206" data-mp="1fv1rtlwirfc1">Light where you look.</p>

        <div className="mx-auto mt-10 grid max-w-3xl gap-3 sm:grid-cols-3" data-id="element-207" data-mp="1kvfu0nbfvv25">
          {offers.map(offer => <a key={offer.id} href="#offer" onClick={() => onSelectOffer(offer.id)} className={`group flex items-center justify-center gap-2 px-5 py-4 font-display text-xl font-extrabold uppercase tracking-wide transition-[background-color,color,transform] duration-150 ease-grit active:translate-y-[2px] ${offer.featured ? 'bg-grit-500 text-ink-950 hover:bg-grit-400' : 'border-2 border-white/25 text-offwhite hover:border-grit-500 hover:text-grit-500'}`} data-id="element-208" data-mp="1tu15xzmeobty">
              {buttonLabels[offer.id]}
              <ArrowRightIcon className="h-5 w-5 transition-transform duration-150 ease-grit group-hover:translate-x-1" aria-hidden="true" data-id="element-209" data-mp="8hhdhhrvepxg" />
            </a>)}
        </div>

        <p className="mt-10 font-display text-2xl font-extrabold uppercase tracking-[0.1em] text-offwhite" data-id="element-210" data-mp="ifdn2555tctg">
          GritVue
        </p>
        <p className="mt-1 text-xs font-bold uppercase tracking-[0.3em] text-steel-400" data-id="element-211" data-mp="2k68kt2ixfm2t">See the job through.</p>
      </div>
    </section>;
}